import { render } from "./SearchModal.vue?vue&type=template&id=0aa0f018&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=0aa0f018&lang=scss&scoped=true"
import "./SearchModal.vue?vue&type=style&index=1&id=0aa0f018&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa0f018"]])

export default __exports__